import * as Types from '../../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OptIntoNovemberReleaseMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type OptIntoNovemberReleaseMutation = { __typename?: 'Mutation', optIntoNovemberRelease: { __typename?: 'BaseMutationResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null } };


export const OptIntoNovemberReleaseDocument = gql`
    mutation OptIntoNovemberRelease {
  optIntoNovemberRelease {
    success
    error {
      code
      message
    }
  }
}
    `;
export type OptIntoNovemberReleaseMutationFn = Apollo.MutationFunction<OptIntoNovemberReleaseMutation, OptIntoNovemberReleaseMutationVariables>;

/**
 * __useOptIntoNovemberReleaseMutation__
 *
 * To run a mutation, you first call `useOptIntoNovemberReleaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptIntoNovemberReleaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optIntoNovemberReleaseMutation, { data, loading, error }] = useOptIntoNovemberReleaseMutation({
 *   variables: {
 *   },
 * });
 */
export function useOptIntoNovemberReleaseMutation(baseOptions?: Apollo.MutationHookOptions<OptIntoNovemberReleaseMutation, OptIntoNovemberReleaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptIntoNovemberReleaseMutation, OptIntoNovemberReleaseMutationVariables>(OptIntoNovemberReleaseDocument, options);
      }
export type OptIntoNovemberReleaseMutationHookResult = ReturnType<typeof useOptIntoNovemberReleaseMutation>;
export type OptIntoNovemberReleaseMutationResult = Apollo.MutationResult<OptIntoNovemberReleaseMutation>;
export type OptIntoNovemberReleaseMutationOptions = Apollo.BaseMutationOptions<OptIntoNovemberReleaseMutation, OptIntoNovemberReleaseMutationVariables>;